import { matchPath } from "react-router-dom";

/**
 * Route pattern -> screen_name, the web counterpart of the app's
 * AppRouteObserver._routeToScreenNameMap. Web-only surfaces (dashboard,
 * settings, devices, patients) are values in here rather than events of their
 * own, so a single screen_view report covers both platforms.
 *
 * Order matters: the first pattern that matches wins, so anything with a
 * literal segment where another route takes a parameter has to come first —
 * /settings/centres/:centreId would otherwise be swallowed by /settings/:id.
 */
const SCREEN_NAME_BY_ROUTE = [
  ["/", "dashboard"],
  ["/dashboard", "dashboard"],
  ["/analytics", "analytics"],

  ["/ecg-reports", "ecg_reports"],
  ["/ecg-reports/:id", "ecg_report_details"],

  ["/test-collections", "test_collections"],
  ["/new-test-collection", "new_test_collection"],
  ["/EditCollectionTasks/:id", "edit_test_collection"],

  ["/settings/centres/:centreId", "centre_details"],
  ["/settings", "settings"],
  ["/settings/:id", "settings_section"],
  ["/profile", "profile"],
  ["/add-member", "add_member"],
  ["/add-centre", "add_centre"],

  ["/cases", "referred_cases"],
  ["/cases/:reportId", "case_details"],

  ["/interpretation", "interpretations"],
  ["/interpretation/:id", "interpretation_details"],

  ["/patients/:id", "patient_details"],
  ["/collectingagents", "collecting_agents"],
  ["/clients", "clients"],
  ["/screening", "screening"],
  ["/facilities", "facilities"],
  ["/manage-facilities", "manage_facilities"],
  ["/import-onboarding", "import_onboarding"],
  ["/onlineconsultation/:id", "online_consultation"],
  ["/help-center", "help_center"],

  ["/onboarding/:id", "onboarding"],
  ["/validate/:id", "onboarding_token_validation"],
  ["/login", "login"],
  ["/loginpassword", "login_password"],
  ["/unauth", "unauthorised"],
];

/**
 * Unmapped paths collapse to a single "unmapped" value rather than being sent
 * raw. Report IDs and centre IDs live in these paths, so echoing the pathname
 * would put identifiers into a dimension that is meant to have low cardinality.
 */
export const UNMAPPED_SCREEN_NAME = "unmapped";

export const getScreenName = (pathname) => {
  if (!pathname) return UNMAPPED_SCREEN_NAME;

  const matched = SCREEN_NAME_BY_ROUTE.find(([pattern]) =>
    matchPath({ path: pattern, end: true }, pathname)
  );

  return matched ? matched[1] : UNMAPPED_SCREEN_NAME;
};
